import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetHomeAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {HTTPSearchRepository} deps.repository
   */
  constructor({repository}) {
    super({repository})

    this._repository = repository
  }

  /**
   * @param {Object} params
   * @param {Array} params.bodyTypes
   * @param {Number} params.fuelType
   * @param {Number} params.kmsMax
   * @param {Number} params.kmsMin
   * @param {String} params.modelLiteral
   * @param {Number} params.model
   * @param {Number} params.brand
   * @param {Number} params.priceMin
   * @param {Number} params.priceMax
   * @param {Number} params.province
   * @param {Number} params.yearMax
   * @param {Number} params.yearMin
   * @param {String} params.keywords
   * @param {Number} params.count
   * @param {Array} params.equipments
   * @param {String} params.version
   * @param {Number} params.transmissionTypeId
   * @param {Number} params.sellerTypeId
   * @param {Number} params.offerType
   * @param {Number} params.minPowerHp
   * @param {Number} params.maxPowerHp
   * @param {Boolean} params.withWarranty
   * @param {Boolean} params.financed
   * @param {Number} params.section1Id
   * @param {Number} params.section2Id
   * @param {Number} params.section3Id
   * @param {Number} params.contractId
   * @param {String} params.sortField
   * @param {String} params.sortType
   * @param {Number} params.offset
   * @return {Promise<Object, Error>} list of vehicles
   * @return {Array<id: number, url: string, img: string, price: number,
   * description: string>}
   */
  execute({
    bodyTypes,
    fuelType,
    kmsMax,
    kmsMin,
    modelLiteral,
    model,
    brand,
    priceMin,
    priceMax,
    province,
    yearMax,
    yearMin,
    keywords,
    count,
    equipments,
    version,
    transmissionTypeId,
    sellerTypeId,
    offerType,
    minPowerHp,
    maxPowerHp,
    withWarranty,
    financed,
    section1Id,
    section2Id,
    section3Id,
    contractId,
    sortField,
    sortType,
    offset
  } = {}) {
    return this._repository
      .getHomeAds({
        bodyTypes,
        fuelType,
        kmsMax,
        kmsMin,
        modelLiteral,
        model,
        brand,
        priceMin,
        priceMax,
        province,
        yearMax,
        yearMin,
        keywords,
        count,
        equipments,
        version,
        transmissionTypeId,
        sellerTypeId,
        offerType,
        minPowerHp,
        maxPowerHp,
        withWarranty,
        financed,
        section1Id,
        section2Id,
        section3Id,
        contractId,
        sortField,
        sortType,
        offset
      })
      .then(ads => ads.toJSON())
  }
}
